export const RouteEnum = {
    DASHBOARD: "/dashboard",
    NOTIFICATIONS: "/meldingen",
    HIGHLIGHTED_COURSES: "/uitgelichte-opleidingen",
    QUALIFICATIONS: "/kwalificaties",
    ACHIEVEMENTS: "/certificaten",
    REVIEWS: "/beoordelen",
    EMPLOYEES: "/medewerkers",
    DATA_MANAGEMENT: "/gegevens-beheren",
    SHOW_ESTABLISHMENT_DETAILS: "/vestigingsgegevens",
    SETTINGS: "/instellingen",
    ESTABLISHMENTS: "/vestigingen",
    SCHEDULED_QUALIFICATIONS: "/ingeplande-kwalificaties",
    CERTIFICATE_EXPIRY: "/verloopt-binnenkort",
};
